import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const AuditFileForm = forwardRef(({audit, section, question, file, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={file}
      type="file"
      fieldsComponent={Fields}
      onSave={({name, file}) => services.audit.saveFile(audit, section, question, name, file)}
      onSaved={onSaved}
    />
  );
});

export default AuditFileForm;
